import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid
} from '@material-ui/core';
import DetailAgent from './DetailAgent';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    colors
  } from '@material-ui/core';
  import Header from '../../components/Header/Header';
  import Sidebar from '../../components/Sidebar/Sidebar';

export default class DetailAgentLayout extends React.Component {

    constructor(props) {
        super(props);
        console.log( this.props );

        let id = props.match.params.id;
        this.state = {
            agent: null,
            agent_id: id
        }
        
    }

    componentOnWilLReceiveProps(props){
        this.setState({ ...this.state, agent_id: props.match.params.id });
    }

    render() {
        return (
            <React.Fragment>
             <Header 
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                /> 
                <main className={this.props.classes.content }>
                    <div className={this.props.classes.toolbar} /> 
                <DetailAgent agent_id={this.state.agent_id} classes={this.props.classes} /> 
                    
                </main> 
                </React.Fragment>
            
        )
    }
}